import { AddressDTO, BuyerCustomerDTO, Res } from 'core/api';
import { ValidationErrors } from 'core/infrastructure';
import * as PrepaymentStatus from '../payments-processing/PrepaymentStatus';
import { DateUtils } from 'core/utils';

export type SalesOrderDataModel = {
	notes: string;
	schedulePreparation: boolean;
	deliveryDate: Date;
	deliveryTime: Date;
	includeDeliveryDate: boolean;
	prepaymentData: PrepaymentStatus.Status;
	customer: BuyerCustomerDTO,
	deliveryAddress: AddressDTO,
	customerDocumentNumber: string
};

export const validateCustomerAndDeliveryDate = (model: SalesOrderDataModel): ValidationErrors => {

	const errors = {};

	if (model.includeDeliveryDate && DateUtils.buildDateTime(model.deliveryDate, model.deliveryTime, 'TRUNC_TO_SECONDS') < new Date())
		ValidationErrors.add(errors, 'deliveryDate', Res.Msg.MSG_DELIVERY_DATE_MUST_BE_EQUAL_OR_GREATER_THAN_TODAY());

	if (model.customer === null || model.customer.Id === 0)
		ValidationErrors.add(errors, 'customer', Res.Msg.MSG_CUSTOMER_MUST_BE_SELECTED());

	return errors;
};